export const basepath = window.location.pathname.split("/")[1];

const events = {
    "testing": {   
        eventId: "9704b06c-acd9-43b7-9858-5aabc198d82d",
        questionId: "e44ee94a-b253-4c06-9593-9f32df14220d",
    },
    "game1": {
        eventId: "9a06473a-b161-486c-b19f-13d30fcf888e",
        questionId: "f9119452-9631-4291-993e-ebb4dd7b4c1f"
    },
    "game2": {
        eventId: "36f5de2b-df46-49af-ac78-2a582cb0775a",
        questionId: "93060323-9b75-47de-b318-359d8f73f49b"
    },
    "game3": {
        eventId: "b41dbc88-df80-4d75-9dba-ff11a244a761",
        questionId: "2b11b00b-c8a2-4eae-821d-9814fb639f43"
    },
    "game4": {
        eventId: "d84f9701-990f-40a9-b9fb-61458567a692",
        questionId: "0d5900d3-d4c4-4b6b-b48a-4d2bcf3540f0"
    },
    "game5": {
        eventId: "d0d654ff-d898-48e0-b089-c1662102750f",
        questionId: "4388cac9-7df8-4e0c-8310-9430844b4844"
    },
    "game6": {
        eventId: "5cba0bd3-14f3-46d4-8e0b-507f30378e6e",
        questionId: "b9178dfe-7108-4e1b-b088-0999d76bee00"
    },
    "game7": {
        eventId: "44109e22-4f0e-4d6a-b4dd-de3bfa4201bd",
        questionId: "2b1495ae-d53a-4205-aa1f-c7b6114a4981"
    },
    "game8": {
        eventId: "70592347-bfca-4f5d-a893-4a84c5fff59e",
        questionId: "b13eccd8-2b03-4838-a8a5-f80ac25801aa"
    }
};

export const isValidEvent = (basepath: string): boolean => {
    if (!basepath) {
        return false;
    }

    return events[basepath.toLowerCase()] !== undefined;
}

export const eventDetails = (basepath: string): { eventId: string, questionId: string} => {
    if (!isValidEvent(basepath)) {
        return undefined;
    }
    return events[basepath.toLowerCase()];
}